export default __webpack_public_path__ + "static/media/8bda7aab26386ad9.d0b77710c5e7b1745ca39da01c9aef62.svg";